import React from "react";
import { useTranslation } from "react-i18next";
import "./BoardsDetailDisclaimer.css";

const BoardsDetailDisclaimer = () => {
  const { t } = useTranslation();

  return (
    <aside className="boardsDetailDisclaimer" aria-label="Disclaimer">
      <div className="boardsDetailDisclaimer-inner">
        <div className="boardsDetailDisclaimer-iconWrap" aria-hidden="true">
          <div className="boardsDetailDisclaimer-diamond">
          </div>
        </div>
        <div className="boardsDetailDisclaimer-text">
          <h2 className="boardsDetailDisclaimer-title">{t("sections.products.boardTabs.disclaimer")}</h2>
          <p className="boardsDetailDisclaimer-body">{t("sections.products.boardTabs.disclaimerBody")}</p>
        </div>
      </div>
    </aside>
  );
};

export default BoardsDetailDisclaimer;
